import React, { useEffect } from "react";

import { containerId, needsContainer } from "../../utils/adConfig";

/**
 * Один вызов `Ya.Context.AdvManager.render` для любого яндексового плейсмента.
 *
 * Заменяет четыре компонента, которые различались только тем, откуда брать
 * контейнер: YandexAd (собирал `yandex_rtb_<blockId>`), AdvManager (брал
 * `option.renderTo`), YandexFullScreen (брал `option.blockId`) и YandexFloorAd
 * (контейнера не имел, зато умел `delay`).
 */
export function YandexAdapter({ entry }) {
    const blockId = entry ? entry.blockId : null;
    const delay = entry ? entry.delay : null;

    useEffect(() => {
        if (!blockId || typeof window === "undefined" || !window.yaContextCb) {
            return undefined;
        }

        const options = { blockId };

        if (entry.type) {
            options.type = entry.type;
        }
        if (entry.platform) {
            options.platform = entry.platform;
        }
        if (needsContainer(entry)) {
            options.renderTo = containerId(entry);
        }

        const render = () => {
            window.yaContextCb.push(() => {
                window.Ya.Context.AdvManager.render(options);
            });
        };

        if (!delay) {
            render();

            return undefined;
        }

        const timer = setTimeout(render, delay);

        return () => clearTimeout(timer);
    }, [blockId, delay]);

    if (!entry || !blockId || !needsContainer(entry)) {
        return null;
    }

    return <div id={containerId(entry)} />;
}

export default YandexAdapter;
